<script>
import useSharedSelectData from "@/use/SharedSelectData";
import {ref, watch} from "vue";

export default {
    name: "BoardingTaskFilter",
    props: {
        value: Object,
        category: String,
        title: String,
    },
    setup(props, {emit}) {
        const {workerPhases, boardingStatus} = useSharedSelectData();
        const panelModel = ref(0);

        const filter = ref({
            category: props.category,
        });

        watch(() => filter.value, () => {
            emit('input', filter.value);
        }, {deep: true});


        return {
            filter,
            workerPhases,
            boardingStatus,
            panelModel
        }
    },
};
</script>

<template>
    <div>
        <v-expansion-panels v-model="panelModel" dense focusable>
            <v-expansion-panel>
                <v-expansion-panel-header>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="mr-n5 ml-n5">
                    <v-container fluid>
                        <v-row dense>
                            <v-col cols="12">
                                <str-worker-autocomplete
                                    v-model="filter.workerId"
                                    :label="'Destinataire'"
                                />
                            </v-col>
                            <v-col cols="12">
                                <organizational-chart-select
                                    v-model="filter.organizationalchartIds"
                                    label="Service"
                                />
                            </v-col>
                            <v-col cols="12">
                                <w-server-autocomplete
                                    v-model="filter.name"
                                    item-value="name"
                                    api="boardingTaskModels"
                                    label="Tâche"
                                />
                            </v-col>
                            <v-col cols="12">
                                <w-date-picker
                                    v-model="filter.startEffectiveDate"
                                    :label="`${$t('boarding.effective_date')} ${$t('common.from')}`"
                                />
                            </v-col>
                            <v-col cols="12">
                                <w-date-picker
                                    v-model="filter.endEffectiveDate"
                                    :label="`${$t('boarding.effective_date')} ${$t('common.to')}`"
                                />
                            </v-col>
                            <v-col cols="12">
                                <w-enum-select
                                    v-model="filter.status"
                                    :label="$t('common.status')"
                                    :items="boardingStatus"
                                />
                            </v-col>
                            <v-col cols="12">
                                <str-worker-autocomplete
                                    v-model="filter.boardingWorkerId"
                                    :label="$t('module.worker')"
                                />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>

        <input type="hidden"/>
    </div>
</template>